import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import SiteLayout from '../Shared/SiteLayout';
import ProductListCard from '../Shared/ProductListCard';
import TextInput from '../Shared/TextInput';
import LoadingButton from '../Shared/LoadingButton';
import Pagination from '../Shared/Pagination';
import Icon from '../Shared/Icon';
import classNames from 'classnames';

const Catalog = () => {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          type: data.filters.type || '',
          category: data.filters.category || '',
          subcategory: data.filters.subcategory || '',
          tag: data.filters.tag || '',
          search: data.filters.search || '',
     });
     

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleSubmit(id) {
          let values = {'id': id};
          Inertia.post(route('site.cart.add'), values).then(() => {
               // setSending(false);
          });
     }

     function handleSearch(e) {
          e.preventDefault();
          Inertia.post(route('site.product.search'), values).then(() => {
               // setSending(false);
          });
     }

     return (
          <React.Fragment>
               <Helmet>
                    <title>{data.caption.products}</title>
               </Helmet>
               <section className="w-full pt-5 pb-10 bg-white">
                    <div className="w-full mx-auto md:container">
                         <div className="w-full md:flex">
                              <div className="p-4 sm:flex md:w-1/4">
                                   <div className="w-full">
                                        <h2 className="w-full text-lg font-bold text-yellow-600 uppercase">{data.caption.search}</h2>
                                        <div className="w-full mt-2 mb-5">
                                             <form onSubmit={handleSearch}>
                                                  <TextInput
                                                        className="block w-full rounded-md shadow-sm form-input"
                                                        label={data.caption.search_product}
                                                        name="search"
                                                        type="text"
                                                        disable={false}
                                                        readonly={false}
                                                        must={true}
                                                        errors={errors.search}
                                                        value={values.search}
                                                        onChange={handleChange}
                                                   />
                                                   <LoadingButton type="submit" loading={sending} className="inline-flex items-center px-4 py-2 mt-2 text-xs font-bold text-white uppercase transition duration-150 ease-in-out border border-transparent rounded-md bg-emerald-700 hover:bg-emerald-900 active:bg-emerald-900 focus:outline-none focus:border-emerald-900 focus:shadow-outline-gray disabled:opacity-25">
                                                       {data.caption.send}
                                                  </LoadingButton>
                                             </form>
                                        </div>
                                        <h2 className="w-full mt-5 text-lg font-bold text-yellow-600 uppercase">{data.caption.filter}</h2>
                                        <ul className="w-full p-2 font-medium list-none list-inside text-emerald-700 text-md">
                                             {data.types.map(({id, name, slug, categories})=>{
                                                  return <li key={`type${id}`}>
                                                       <InertiaLink className={`flex items-center font-semibold underline px-2 py-4 border-b border-b-gray-200 text-${(values.type == name)?'emerald':'gray'}-600 hover:text-emerald-600 hover:bg-gray-200 hover:rounded-md`} href={route('site.product.category', {type: name})}>
                                                            <Icon name={'book'} className={'fill-current w-3 h-3 mr-2'} />{name}
                                                       </InertiaLink>
                                                       {(categories.length > 0 && (values.type == name)) && (<ul className="p-2 ml-4 text-sm font-semibold list-inside rounded-md">
                                                            {categories.map(({cid, cname, cslug, subcategory})=>{
                                                                 return <li key={`sub${cid}`}>
                                                                      <InertiaLink className={`flex items-center underline px-2 py-4 border-b border-b-gray-200 ${(values.type == name && values.category == cslug)?'text-emerald-600':'text-gray-600'} hover:text-emerald-600 hover:bg-gray-200 hover:rounded-md`} href={route('site.product.category', {type:name, category:cslug})}>
                                                                           <Icon name={'book'} className={'fill-current w-3 h-3 mr-2'} />{cname}
                                                                      </InertiaLink>
                                                                      {(subcategory.length > 0 && (values.type == name && values.category == cslug)) && (<ul className="p-2 ml-4 text-sm font-semibold list-inside rounded-md">
                                                                           {subcategory.map(({sid, sname, sslug, tags}, i) => {
                                                                                return <li key={`sub${sid}`}>
                                                                                     <InertiaLink className={`flex items-center underline px-2 py-4 border-b border-b-gray-200 ${(values.type == name && values.category == cslug && values.subcategory == sslug)?'text-emerald-600':'text-gray-600'} hover:text-emerald-600 hover:bg-gray-200 hover:rounded-md`} href={route('site.product.category', {type:name, category:cslug, subcategory:sslug})}>
                                                                                          <Icon name={'book'} className={'fill-current w-3 h-3 mr-2'} />{sname}
                                                                                     </InertiaLink>
                                                                                     {(tags.length > 0 && (values.type == name && values.category == cslug && values.subcategory == sslug)) && (<ul className="p-2 ml-4 text-sm font-semibold list-inside rounded-md">
                                                                                          {tags.map(({tid, tname, tslug}) => {
                                                                                               return <li key={`tag${tid}`}>
                                                                                                    <InertiaLink className={`flex items-center underline px-2 py-4 border-b border-b-gray-200 ${(values.type == name && values.category == cslug && values.subcategory == sslug && values.tag == tslug)?'text-emerald-600':'text-gray-600'} hover:text-emerald-600 hover:bg-gray-200 hover:rounded-md`} href={route('site.product.category', {type:name, category:cslug, subcategory:sslug, tag:tslug})}>
                                                                                                         <Icon name={'book'} className={'fill-current w-3 h-3 mr-2'} />{tname}
                                                                                                    </InertiaLink>
                                                                                               </li>
                                                                                          })}
                                                                                     </ul>)}
                                                                                </li>
                                                                           })}
                                                                      </ul>)}
                                                                 </li>
                                                            })}
                                                       </ul>)}
                                                  </li>
                                             })}
                                        </ul>
                                   </div>
                              </div>
                              <div className="p-4 md:w-3/4">
                                   <div className="grid w-full grid-cols-1 gap-1 md:grid-cols-2 md:gap-2 lg:grid-cols-3 lg:gap-3">
                                        {data.products.data.map(({id, name, code, slug, category, type, currency, price, promotion, description, image, available, online, addCart, naonline}) => {
                                             return <React.Fragment key={`prod${id}`}>
                                                  <ProductListCard key={`pr${id}`}
                                                       link="site.catalog.show"
                                                       onAddToCart={()=>handleSubmit(id)}
                                                       product={{id, name, code, slug, category, type, currency, price, promotion, description, image, available, online, btn_caption:data.caption.details, special_caption:data.caption.promo_price, addCart, naonline}} />
                                             </React.Fragment>
                                        })}
                                   </div>
                                   {(data.products.data.length > 0) && (<div className="col-span-12 mt-4">
                                        <Pagination links={data.products.links} />
                                   </div>)}
                                   {(data.products.data.length == 0) && (<div className="items-center w-full h-10 font-semibold text-center text-yellow-700 bg-yellow-200 rounded justify-content-center">
                                        {data.caption.no_product}
                                   </div>)}
                              </div>
                         </div>
                    </div>
               </section>
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Catalog.layout = page => <SiteLayout children={page} header={'Catalog'} />;

export default Catalog;
